import React from "react";
import { useParams } from "react-router-dom";
import { isContinentSlug } from "../data/locationData";
import ContinentPage from "./ContinentPage";
import CityPage from "./CityPage";

const LocationRouter = () => {
  const { slug } = useParams();

  if (isContinentSlug(slug)) {
    return <ContinentPage />;
  }

  return <CityPage />;
};

export default LocationRouter;
